module.exports = __webpack_public_path__ + "img/chat-2.f610df9a.svg";